<template>
  <div id="itemlist" class="overflow-auto" style="height: 800px;background:#f1f1f1;">
    <div v-if="showDetail" style="height: 1300px;"  >
      <a-spin size="large" :spinning="spinning"  tip="資料處理中..."> 
        <b-button  class="fontstyle1" variant="link" @click="toMaster()">
                  ( 回上一頁 )
        </b-button>
        <div style="padding:0.3rem;">
          <a-card title="" :bordered="false" style="width: 99.5%">
            <img
              slot="cover"
              alt="example"
              :src="fiData.url"
            />            
            <h5><strong><span v-text="fiData.actitle"></span></strong></h5>
            <div class="text-left" >              
              <div class="classempy">
                <b-icon icon="clock" variant="success"></b-icon> 活動時間 : <br/>
                <span style="font-size: 14px;" v-text="fiData.sdate  +' ~ ' + (fiData.edate==fiData.sdate?'':fiData.edate)"></span>
              </div>
              <div class="classempy">
                <b-icon icon="geo-alt" variant="success"></b-icon> 活動地點 : <br/>
                <span style="font-size: 14px;" v-text="fiData.address"></span>
              </div>  
              <a-checkbox @change="onChange">
                  全選/取消
              </a-checkbox>

            <div class="ccle">           
              <div style="width: 380px; border: 1px solid #d9d9d9; border-radius: 10px; padding:0.5em;margin-top:0.2em;margin-bottom: 0.3rem;" >                                    
                  <a-calendar @select="onSelect" :defaultValue="currentTime" :locale="locale" :disabledDate="disabledDate" :fullscreen="true">
                      <div slot="dateCellRender" slot-scope="value" class="events" style="overflow-x: hidden;overflow-y:hidden;">
                          <div v-for="item  in getListData(value)" :key="item.id"   >
                          <div 
                            class="notes" 
                            :style="{
                              'background-image': item.type === 'Y' 
                                ? 'linear-gradient(to bottom, #c5ddf8, #3386e7)' 
                                : 'linear-gradient(to bottom, #dbdedb, #aeb1ae)',
                              'cursor': 'pointer'
                            }"
                          >

                            <p style="margin-top: 0.5rem; color: aliceblue; font-size: 1rem; font-weight: bold;">
                              {{ item.type === 'Y' ? '請選擇' : '不能選' }}
                            </p>
                          </div>
                          </div>
                      </div>
                      <template slot="monthCellRender" slot-scope="value">
                          <div v-if="getMonthData(value)" class="notes-month">
                          <section>{{ getMonthData(value) }}</section>
                          <span>Backlog number</span>
                          </div>
                      </template>
                  </a-calendar>



              </div>  
              <b-form ref="myForm"  v-on:submit.prevent="applyForm">
              <div v-if="selectitem.length > 0" class="iphone-style-container">
                <ul class="iphone-style-list">
                  <li v-for="item in selectitem" :key="item.id" class="iphone-style-item">
                    <div class="iphone-style-box">
                      <span v-text="getdate(item.sdate) + ' '" class="iphone-style-text"></span>
                      <span @click="removes(item.id)" v-text="'(刪除)'" class="iphone-style-delete"></span>
                    </div>
                  </li>
                </ul>

                <a-alert v-if="showmsg" :message="mms" type="success" show-icon />
                <div v-if="list1.length>0" style="width: 100%;margin-top:0.3rem;">
                  <div v-if="fiData.fee">                    
                      <div class="form-group" id="fees"> 
                         <label for="idexample">活動參加費用 <span style="color:red">*</span></label>                         
                              <a-row type="flex" >
                                  <a-col :span="7" :offset="1" v-for="items in fiData.items" :key="items.id">
                                          <div >       
                                              <span> 
                                                  <input v-model="selecteds" name="customRadioInline1" type="radio" :value="items.id" required/>                                                  
                                                  費用: {{items.fee}} TWD / {{ items.title }} 
                                              </span>
                                          </div>                            
                                  </a-col>                  
                              </a-row>                                
                      </div>
                  </div>                                     
                  <div class="list-group-item" v-for="element in list1" :key="element.id"> 
                      <div class="form-group" v-if="element.input=='text' || element.input=='email' || element.input=='tel' || element.input=='date' || element.input=='file' ">
                          <label for="idexample">{{ element.name }}</label> 
                          <input v-model="element.val" :readonly="element.name === '帳號'"  :type="element.input" class="form-control" id="idexample" autocomplete="off" :required="element.required" aria-describedby="emailHelp" :placeholder="element.placeholder">
                      </div> 
                      <div class="form-group" v-if="element.input=='radio' || element.input=='checkbox'">
                          <label for="idexample">{{ element.name }}</label>
                          <br />
                              <a-row type="flex" >
                                  <a-col :span="5" :offset="1" v-for="obj in element.list" :key="obj.value">
                                          <div >       
                                              <span> 
                                                  <input v-if="element.input=='radio'" v-model="element.val" :name="`radio-${element.id}`" :type="element.input" :value="obj.value"/>
                                                  <input v-if="element.input=='checkbox'" v-model="element.ary[obj.value]" :name="element.id" :type="element.input" :value="obj.value"/> 
                                              : {{ obj.text }} 
                                              </span>
                                          </div>                            
                                  </a-col>                  
                              </a-row>                                
                      </div> 
                      <div class="form-group" v-if="element.input=='select'">
                          <label for="idexample">{{ element.name }}</label>
                          <br />
                          <select v-model="element.val" class="custom-select">
                              <option selected>--請選擇---</option>
                              <option v-for="obj in element.list" :key="obj.value" :value="obj.value">{{obj.text}}</option>
                          </select>   
                      </div>
                  </div>                                                        
                </div>                
                <div style="padding:0.25rem 0 0 0;" />
                <b-button type="submit" squared variant="primary" :disabled="disables"  block>
                   <b-spinner v-if="disables" small type="grow"></b-spinner>
                   立即報名
                   <b-icon icon="arrow-up-circle-fill" aria-hidden="true"></b-icon>
                </b-button>
                 <div style="padding:0.05rem 0 0 0;" />             
              </div>
              </b-form>
              <div style="padding:12.8rem 0 0 0;" />
            </div>         
            </div>
          </a-card>
        </div>
      </a-spin>        
    </div>

    <div style="height: 960px;" v-if="!showDetail">
      <div
        class="post-preview"
        v-for="(item, $index) in aclist"
        :key="$index"
        style="margin:0px 0px 5px 0px;"
      >
        <div>
            <div class="cards" :style="{'background-color': $index%2===0?'#549bed':'#ec8952'}">
              <img :src="item.url" alt="dog" />
              <div class="cards-details">
                <span v-text="item.actitle" class="fontstyle" />
                <br />
                <span v-text="'活動類別 : '+ getinfo(item.theme)" class="fontstyle" />
                <br />
                <span v-text="'活動日期 :'" class="fontstyle" />
                <br />
                <span v-html="fdateformat(item)" class="fontstyle" />
                <br />
                <b-button v-if="item.acts_actclass[0].checked==false" class="fontstyle1" variant="link" @click="toDetail(item)">
                  ( 報名 )
                </b-button>
                <span v-if="item.acts_actclass[0].checked" v-text="'該活動有人數限制'" class="fontstyle2" />
              </div>
            </div>
        </div>
      </div>
      <div style="padding:10.5rem 0 0 0;" />
      <infinite-loading @infinite="infiniteHandler" spinner="waveDots" :distance="5">
        <span slot="no-more">
          <a-spin tip>
            <div class="spin-content">資料已經到底了, 謝謝。。。</div>
          </a-spin>
        </span>
      </infinite-loading>
      <div style="padding:3.5rem 0 0 0;" />
    </div>
  </div>
</template>

<script>
import * as moment from "moment/moment";
import { actService, joinService} from "../../../_services";
import MY_JSON from "../../../assets/json/optiondata.json";
import Formdata from '../../../assets/json/formdata.json'
import { mapState } from "vuex";
import 'moment/locale/zh-tw';
import InfiniteLoading from "vue-infinite-loading";

const queryACata = obj => {
  return actService.getactlistall(obj);
};  

const postdata = obj => {
  return  joinService.postformm(obj)
}


export default {
  name: "Viewper",
  components: {
    InfiniteLoading
  },
  props: {
    msg: String,
    item: Array,
  },
  data() {
    return {
      myJson: MY_JSON,
      myForm: [],
      showDetail: false,
      spinning:false,
      disables:false,
      showmsg:false,
      page: 1,
      selected :'all',
      aclist: [],
      fiData:null,
      currentTime:moment(),
      others:[],
      selectitem:[],
      list1: [],
      mms:"資料新增成功",
      locale:{
        lang:{
          month:'月',
          year:'年',
        }
      },      
    };
  },
  async mounted() {
  },
  computed: {
    ...mapState("account", ["user"])
  },

  methods: {
    fdateformat(val) {
      return (
        moment(val.sdate).format("YYYY-MM-DD HH:mm") +
        "~" +
        moment(val.edate).format("MM-DD HH:mm")
      );
    },
    catImg(imgs) {
      return require(`../../../assets/img/${imgs}`);
    },
    getinfo(theme) {
      let url = this.myJson.find(rs => rs.value == theme).title;
      return url;
    },

    getxt(val) {
      return val.substring(1, 32);
    },

    ontype(val) {
      this.selected = val;
      this.infiniteHandler();
    },

    async toDetail(val){
        this.fiData = val
        this.selectitem =[]
        await this.inidata()
        this.showDetail=true
    },

    toMaster(){
        this.showDetail=false
    },  

	async infiniteHandler($state) {
      let params = {
        page: this.page,
        size: 4,
        type: this.selected,
        states: "Y"
      };
      let rs=await this.getRuner(params)
      if(rs){
        $state.loaded();
      }else{
        $state.complete();
      }
    },

    getRuner(params) {
      return new Promise((resolve) => {
      this.page++;
      queryACata({
        ...params
      }).then(({ data }) => {
        let obj = {
          hits: data.data
        };
        if (obj.hits == null) {
          obj.hits = [];
        }
        if (obj.hits.length) {
          this.aclist.push(...obj.hits);
          resolve(true);
        } else {
          resolve(false);
        }
      });
      });
    },


    getMonthData(value) {
      if (value.month() === 8) {
        return 1394;
      }
    },    

    getListData(value) {
      let listData=[];
      if(this.fiData.acts_actclass!==null){ 
        this.fiData.acts_actclass.forEach((item)=>{          
          if(moment(item.sdate).format('YYYY-MM-DD') == value.format("YYYY-MM-DD")){
              let state = moment(item.edate).format('YYYY-MM-DD HH:mm') >=this.currentTime.format("YYYY-MM-DD HH:mm")?'Y':'N'                             
              listData.push(
                  {
                    type:  state,
                    id:item.id,
                    fid:item.fid,          
                    orgid:item.orgid,       
                    url:item.url,           
                    actitle:item.actitle,          
                    sdate:item.sdate,         
                    edate:item.edate,                     
                    state:item.status                                                                                          
                }
              )
          }            
          });
          return listData || [];
      }
      return listData || [];

    },
    
    disabledDate(value){
      if(this.fiData.acts_actclass!==null){ 
        let state = ''
        this.fiData.acts_actclass.forEach((item)=>{          
          if(moment(item.sdate).format('YYYY-MM-DD') == value.format("YYYY-MM-DD")){
              state = moment(item.edate).format('YYYY-MM-DD HH:mm') >=this.currentTime.format("YYYY-MM-DD HH:mm")?'Y':'N'  
              return                           
          }            
          });
          return state=='N'? true:false  
      }  
    },       

    onChange(e){
      if(e.target.checked==true){
        let item = this.fiData.acts_actclass
        for (let i = 0; i < item.length; i++) {
          if(this.getformat(item[i].edate) > this.getformat(this.currentTime)){
            this.selectitem.push({obj:item[i],id:item[i].id,fid:this.fiData.id,orgid:this.fiData.orgid});
          }
        }
      }else{
        this.selectitem =[]
      }

    },  
    
    onSelect(e){
      let tmp = this.getdate(e._d);
      this.others=[]
        let obj = this.fiData.acts_actclass.filter(rs=>moment(rs.sdate).format("YYYY-MM-DD")==tmp)
        if(obj.length>0 && this.getformat(obj[0].edate) > this.getformat(this.currentTime)){          
            if(this.oncheck(obj[0].id).length==0){
              this.selectitem.push({obj:obj[0],id:obj[0].id,fid:this.fiData.id,orgid:this.fiData.orgid});
            }
        }    
    },
    
    oncheck(val){
      return this.selectitem.filter(rs=>rs.obj.id==val)
    },    

    getdate(val){
        return moment(val).format("YYYY-MM-DD"); 
    },      
    getformat(val){
        return moment(val).format("YYYY-MM-DD HH:mm"); 
    },   
    removes(val) {
      console.log(val)
      this.selectitem = this.selectitem.filter(rs=>rs.id!=val)
    }, 
    
    showSuccess(){
      this.showmsg = true
      setTimeout(() => {  
        this.showmsg=false
        clearInterval();
        }, 2000);
    },

    async inidata(){  
        this.list1=[]            
        if(JSON.stringify(this.fiData)!=='{}'){ 
            this.list1 =[]
            for(var i in this.fiData.options){
                let tmp= await this.myForm.filter((el)=>{return el.id ===this.fiData.options[i].oid})
                let rs  = tmp[0]
                if(rs.id==1){
                  rs.val = this.user.data.user.username
                }else if(rs.id==2){
                  rs.val = this.user.data.user.hphone!==undefined?this.user.data.user.hphone:'' 
                }else if(rs.id==3){
                  rs.val = this.user.data.user.email
                }else if(rs.id==8 || rs.id==19){
                  rs.ary = {} 
                }else if( rs.id==18 || rs.id==17 || rs.id==16 || rs.id==15 || rs.id==14 || rs.id==13 || rs.id==12 || rs.id==11 || rs.id==10 || rs.id==9 || rs.id==7 || rs.id==6 || rs.id==5 || rs.id==4){
                  rs.val = ""
                }
                this.list1.push(tmp[0])
            }           
        }           
    },    
    
    async applyForm(){
      this.disables=true
      this.spinning=true
      let Tmps=[];
      let Join =[]

      let items =[]         
      this.others =[]
      for(var obj in this.list1){

        if (this.list1[obj].input === 'radio' && !this.list1[obj].val) {
              this.$message.error(`請選擇 ${this.list1[obj].name}`);
              return false;
        }

        if (this.list1[obj].input === 'checkbox') {
          const isChecked = Object.values(this.list1[obj].ary).some((value) => value === true);
          if (!isChecked) {
            this.$message.error(`請至少選擇一個 ${this.list1[obj].name}`);
            return false;
          }
        }

        if (this.list1[obj].input === 'select' && (!this.list1[obj].val || this.list1[obj].val === '')) {
          this.$message.error(`請選擇 ${this.list1[obj].name}`);
          return false;
        }        
        
        if(this.list1[obj].input==='checkbox')
        {     
          let tmp = Object.entries(this.list1[obj].ary)
          for(var rs in tmp){
            if(tmp[rs][1]==true){                          
              items.push({
                oid: this.list1[obj].id,
                items:tmp[rs][0].toString()
              }) 
            }
          }       
        }else{
          items.push({
                oid: this.list1[obj].id,
                items:this.list1[obj].val.toString()
              }) 
        }
      }


      
      for(var s in this.item){
        Tmps =[]
        for(var k in this.selectitem){
          Tmps.push({
            id : this.selectitem[k].id,
            fid : this.selectitem[k].fid,
            uid :  this.item[s].uid,     //申請者
            orgid : this.selectitem[k].orgid,
            sdate : this.selectitem[k].obj.sdate ,   // 舉辦日期
            edate : this.selectitem[k].obj.edate ,   // 結束日期
            states: 'N' ,   // 狀態
            roles : 'actor',    // 活動角色
            myrsoptions:items,    
          })
        }
        Join.push({
          uid : this.item[s].uid,
          roles : 'actor',    // 活動角色  
          gedata : Tmps
        })
      }
      postdata(Join).then(({data}) =>{
          if(data!==null){
            data=="error"? this.mms="新增錯誤":"資料新增成功"
            data=="double"?this.mms="資料重覆新增":"資料新增成功"
            setTimeout(() => {  
              this.showSuccess()
              this.disables = false;
              this.spinning=false
              clearInterval();
              }, 3000);
          }
           
                      
      });        
    }

  },
  created() {    
    this.myForm = Formdata 
    //console.log("created:",this.list1)
  },
  destroyed() {
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.spin-content {
  border: 1px solid #91d5ff;
  background-color: #e6f7ff;
  padding: 30px;
}

#itemlist {
  margin: 0px auto;
  padding: 0px;
  max-width: 1024px;
}

img {
  max-width: 100%;
  min-height: 100%;
  object-fit: cover;
  display: block;
  clip-path: polygon(-4px -4px, 100.4% -3px, 99.2% 102.57%, -0.8% 102.97%);
}

.cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: auto;
  width: min(98%, 500px);
  margin: 0 auto;
  box-shadow: 0 20px 34px hsla(20deg, 1%, 52%, 0.29);
  overflow: hidden;
}

.cards-details {
  position: relative;
  padding: 0 0.05rem 0 0.5rem;
}

.fontstyle {
  font-size: 0.8rem;
  color: #ffffff;
}

.fontstyle1 {
  font-size: 0.9rem;
  font-weight: bold;
  color: #091dd1;
}
.fontstyle2 {
  font-size: 0.8rem;
  color: hsl(145, 86%, 80%);
}

.spin-content {
  padding: 60px;
  box-shadow: 0 20px 34px hsla(20deg, 1%, 52%, 0.29);
}

.classempy{
  padding:0;
}

.ccle {
	margin: 0px auto;
}

.notes{
  position: absolute;
  border-radius: 15px;
  top: 25%;
  left: 0;
  width: 80%;
  height: 70%;
  text-align: center; /* 文本水平居中 */
  vertical-align: middle; /* 文本垂直居中 */  
  cursor:pointer;
  }


.rsgrid li { 
  display: inline-block;
	vertical-align: top;
  font-size:0.9em;
  line-height: 1.5em;
}

#rcorners3 {
  border-radius:  15px 15px;
  font-size:0.9em;
  text-align: center;
  color:#f7f5f0;
  background: #436b72;
  padding: 0.2em; 
  width: 110px;
  height: 25px; 
  margin: 0.18em;
}
.iphone-style-container {
  display: flex; /* 使用 Flexbox 排版 */
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  flex-direction: column; /* 垂直排列 */
  width: 100%; /* 占滿父容器寬度 */
  max-width: 980px; /* 限制最大寬度，與 a-calendar 一致 */
  border: 1px solid #d9d9d9; /* 邊框樣式 */

  padding: 0.5rem; /* 添加內距 */
  background-color: #f9f9f9; /* 柔和背景色 */
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1); /* 添加陰影 */
}

.iphone-style-list {
  list-style: none; /* 移除列表樣式 */
  padding: 0; /* 移除內距 */
  margin: 0; /* 移除外距 */
  display: flex; /* 使用 Flexbox 排版 */
  flex-wrap: wrap; /* 子元素換行排列 */
  gap: 0.5rem; /* 控制子元素間距 */
  justify-content: center; /* 子元素居中 */
}

.iphone-style-item {
  display: inline-block; /* 讓列表項目水平排列 */
}

.iphone-style-box {
  border-radius: 15px; /* 圓角設計 */
  font-size: 0.9em; /* 調整文字大小 */
  text-align: center; /* 文字居中 */
  color: #f7f5f0; /* 文字顏色 */
  background: #639ea8; /* 背景色 */
  padding: 0.5em; /* 添加內距 */
  width: 135px; /* 固定寬度 */
  height: 35px; /* 固定高度 */
  display: flex; /* 使用 Flexbox 排版 */
  align-items: center; /* 垂直居中 */
  justify-content: space-between; /* 文字與刪除按鈕分開 */
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1); /* 添加陰影 */
}

.iphone-style-text {
  font-weight: bold; /* 加粗文字 */
}

.iphone-style-delete {
  cursor: pointer; /* 鼠標樣式 */
  color: #f7f5f0; /* 刪除按鈕顏色 */
  font-size: 0.8em; /* 調整刪除按鈕文字大小 */
}
  
</style>
<style>
.ant-fullcalendar-header{
  padding:10px;
  margin-top:-10px;
}
.ant-fullcalendar-header .ant-radio-group {
    display: none !important;
}
.ant-fullcalendar-year-select{
    padding:5px;
}
.ant-fullcalendar-month-select{
      left: -3px;
}
.ant-fullcalendar{
  font-size:12px;
  font-weight: bold;
}
</style>





